import Noty from 'noty';

export const success = (message) => {
  new Noty({
    type: 'success',
    layout: 'bottomRight',
    text: message,
    theme: 'metroui',
    progressBar: false,
    timeout: 2000,
  }).show();
};

export const error = (message = null) => {
  new Noty({
    type: 'error',
    layout: 'bottomRight',
    text: message,
    theme: 'metroui',
    progressBar: false,
    timeout: 3000,
  }).show();
};
